<template>
  <div class="relative">
    <RouterView />
    <ToastWrapperFragment />
  </div>
</template>

<script setup lang="ts">
import { onBeforeMount, onMounted, onUnmounted } from 'vue';
import { RouterView } from 'vue-router';
import { useI18n } from 'vue-i18n';
import type { AppProps } from '@client/ClientApp.types';
import { NetworkDependencyTypes } from '@shared/common/network/network.dependency-types';
import type { JwtRepositoryInterface } from '@shared/common/network/domain/repository/jwt.repository';
import { container } from '@shared/common/dependency-injection/domain/container';
import { ToastWrapperFragment } from '@kiplin/web-common/toast';
import type { AppPresenter } from '@shared/common/app/domain/presenter/app.presenter';
import { AppDependencyTypes } from '@shared/common/app/app.dependency-types';

const props = withDefaults(defineProps<AppProps>(), {
  appEnvironment: 'prod',
});

const i18n = useI18n();
const jwtRepository = container.get<JwtRepositoryInterface>(NetworkDependencyTypes.JwtRepository);
const appPresenter = container.get<AppPresenter>(AppDependencyTypes.AppPresenter);

onBeforeMount(() => {
  updateI18nConfig();
  if (props.apiToken) {
    jwtRepository.saveToken(props.apiToken);
  }
});

onMounted(() => {
  void appPresenter.initialize();
});

onUnmounted(() => {
  void appPresenter.destroy();
});

function updateI18nConfig(): void {
  i18n.locale.value = props.userLocale;
}
</script>
